import {
  ExpenseType,
  IncomeOrExpenseState,
  IncomeType,
  IncomeExpenseCategoryType,
} from 'further-types/lp/income-and-expenses';

export const IncomeAndExpensesLabels = {
  [IncomeType.DepositInterestIncome]: 'Deposit interest income',
  [IncomeType.DividendIncome]: 'Dividend income',
  [IncomeType.InterestIncome]: 'Interest income',
  [IncomeType.InterestOutsideOfCarryIncome]: 'Interest - outside of carry',
  [IncomeType.OtherOutsideOfCarryIncome]: 'Other income - outside of carry',
  [IncomeType.OtherIncome]: 'Other income',
  [IncomeType.AccruedIncome]: 'Accrued income',
  [ExpenseType.AccountingFeeExpense]: 'Accounting fee expense',
  [ExpenseType.AdministrationFeeExpense]: 'Administration fee expense',
  [ExpenseType.AdvisoryFeeExpense]: 'Advisory fee expense',
  [ExpenseType.AifmFeeExpense]: 'AIFM fee expense',
  [ExpenseType.AuditFeeExpense]: 'Audit fee expense',
  [ExpenseType.BankCharges]: 'Bank charges',
  [ExpenseType.ConsultancyFeeExpense]: 'Consultancy fee expense',
  [ExpenseType.CustodianFeeExpense]: 'Custodian fee expense',
  [ExpenseType.DepositoryFeeExpense]: 'Depository fee expense',
  [ExpenseType.DirectorsFeeExpense]: 'Directors fee expense',
  [ExpenseType.IncentiveFeeExpense]: 'Incentive fee expense',
  [ExpenseType.InformationTechnologyExpense]: 'Information technology expense',
  [ExpenseType.InsuranceExpense]: 'Insurance expense',
  [ExpenseType.OtherExpense]: 'Other expense',
  [ExpenseType.LegalAndProfessionalFeesExpense]:
    'Legal and professional fees expense',
  [ExpenseType.ManagementFee]: 'Management fee',
  [ExpenseType.OperatingExpense]: 'Operating expense',
  [ExpenseType.OperationAndMaintenanceExpense]:
    'Operation and maintenance expense',
  [ExpenseType.OrganisationExpense]: 'Organisation expense',
  [ExpenseType.PlacementFeeExpense]: 'Placement fee expense',
  [ExpenseType.RegulatoryAndTaxFee]: 'Regulatory and tax fee',
  [ExpenseType.ReimbursementFeeExpense]: 'Reimbursement fee expense',
  [ExpenseType.SecretarialFeeExpense]: 'Secretarial fee expense',
  [ExpenseType.SundryExpense]: 'Sundry expense',
  [ExpenseType.TaxationExpense]: 'Taxation expense',
  [ExpenseType.TravelAndEntertainmentExpense]:
    'Travel and entertainment expense',
  [ExpenseType.InterestExpense]: 'Interest expense',
  [ExpenseType.AccruedExpense]: 'Accrued expense',
  // Gain/Loss categories
  [IncomeExpenseCategoryType.RealisedGainOnInvestments]:
    'Realised gain / (loss) on investments',
  [IncomeExpenseCategoryType.UnrealisedGainOnInvestments]:
    'Unrealised gain / (loss) on investments',
  [IncomeExpenseCategoryType.RealisedFXGainOnInvestments]:
    'Realised FX gain / (loss) on investments',
  [IncomeExpenseCategoryType.UnrealisedFXGainOnInvestments]:
    'Unrealised FX gain / (loss) on investments',
  [IncomeExpenseCategoryType.OtherRealisedFXGain]:
    'Other Realised FX gain / (loss)',
  [IncomeExpenseCategoryType.OtherUnrealisedFXGain]:
    'Other Unrealised FX gain / (loss)',
};

export function parseIncomeExpenseCategory(
  value: string | undefined | null,
): string | null {
  if (!value) return null;
  const normalized = value.toLowerCase().trim();
  const entry = Object.entries(IncomeAndExpensesLabels).find(
    ([, label]) => label.toLowerCase() === normalized,
  );
  return entry ? entry[0] : null;
}

export const IncomeOrExpenseStateLabels: Record<IncomeOrExpenseState, string> =
  {
    [IncomeOrExpenseState.Payable]: 'Payable expense',
    [IncomeOrExpenseState.Receivable]: 'Receivable income',
    [IncomeOrExpenseState.Accrued]: 'Accrued',
  };
